'use client';

import { cn } from '@/lib/cn';
import type { Message } from '@repo/api';

interface AppointmentSlotsCardProps {
  message: Message;
  onSlotSelect: (value: string, message: Message) => void;
}

export function AppointmentSlotsCard({ message, onSlotSelect }: AppointmentSlotsCardProps) {
  const slots = (message.contentData as any[]) || [];
  const anyItemSelected = slots.some((slot: any) => slot?.isSelect === true);

  return (
    <div className="ml-12">
      <div className="w-full flex-col justify-center space-y-2 -ml-1">
        {slots.map((slot: any, index: number) => {
          return (
            <button
              key={index}
              onClick={() => onSlotSelect(slot.value, message)}
              disabled={anyItemSelected}
              className={cn(
                'flex items-center gap-2 px-4 py-3 rounded-full border transition-colors',
                'text-left min-w-[200px]',
                slot.isSelect
                  ? 'bg-active ring-1 ring-accent ring-inset border-accent'
                  : 'bg-primary hover:bg-secondary text-primary border-secondary',
                anyItemSelected && !slot.isSelect && 'opacity-50 !cursor-not-allowed',
              )}
            >
              {slot.icon && (
                <span className="flex-shrink-0 flex items-center justify-center">
                  <img src={slot.icon} alt="" width={16} height={16} className="object-contain" />
                </span>
              )}
              <span className="text-body-2">{slot.text}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
